import { createAsyncThunk } from '@reduxjs/toolkit';
import { api } from 'api';
import { generalExtraActions } from './general';

const authExtraActions = {
  login: createAsyncThunk('auth/login', api.login),
  profilePatch: createAsyncThunk('auth/profilePatch', api.profilePatch),
  changePassword: createAsyncThunk('auth/changePassword', api.changePassword),
};

export default authExtraActions;
